import { MonitoringChartData } from '@app/monitoring/common/monitoring-metrics.types';

export const searchMetric = function (item: MonitoringChartData, searchValue: string | null = null) {
  const searchText = searchValue?.toLocaleLowerCase() ?? '';
  return searchText.trim().length === 0 ? true : (item.title ?? '').toLocaleLowerCase().includes(searchText);
};
